import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Modal, Input, Button, ButtonToolbar} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm, checkboxField} from '../../core/redux/form'
import extract from '../../core/extract'
import {supportWorker} from '../../core/browser'
import Icon from '../../core/components/Icon'
import CheckboxToggle from '../../core/components/CheckboxToggle'
import ButtonToggle from '../../core/components/ButtonToggle'
import {EXPORT_XLSX_TICKETS_OPTION_UPDATED, EXPORT_PDF_TICKETS_OPTION_UPDATED, REPORT_PDF_TICKETS_OPTION_UPDATED, exportXlsxTickets, exportPdfTickets, exportPdfTicket, reportPdfTickets, updateExportXlsxTicketsOption, updateReportPdfTicketsOption} from '../actions'
import {XLSX_TICKET_SHEET_COLUMNS, PDF_EXPORT_PAGES, PDF_REPORT_PAGES, ExportXlsxTicketsOption, ExportPdfTicketsOption, ReportPdfTicketsOption} from '../models'
import i18n from '../i18n'
import style from './ExportTicketsModal.less'

const PDF_TICKET_MAX_COUNT = 350
const EXPORT_TYPES = ['ExportXlsx', 'ExportPdf', 'ReportPdf']

function restrictExportTypes(ticket) {
    if (ticket) return ['ExportPdf']
    return EXPORT_TYPES
}

class ExportTicketsModal extends Component {
    static propTypes = {
        ticket: PropTypes.object,
        onHide: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
            exportTypes: []
        }
    }

    componentWillMount() {
        const {dispatch, exportXlsxTicketsOption, reportPdfTicketsOption, ticket} = this.props

        const exportTypes = restrictExportTypes(ticket)
        const exportType = exportTypes[0]
        this.setState({exportTypes, exportType})

        if (!exportXlsxTicketsOption) {
            dispatch(updateExportXlsxTicketsOption({
                ticketSheetColumns: XLSX_TICKET_SHEET_COLUMNS,
                ticketSheetAdditionalData: true
            }))
        }

        if (!reportPdfTicketsOption) {
            dispatch(updateReportPdfTicketsOption({
                pages: PDF_REPORT_PAGES
            }))
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.ticket != this.props.ticket) {
            const {ticket} = nextProps

            const exportTypes = restrictExportTypes(ticket)
            const exportType = exportTypes[0]
            this.setState({exportTypes, exportType})
        }
    }

    _exportXlsx() {
        const {dispatch, query, exportXlsxTicketsOption, onHide} = this.props

        if (!supportWorker()) {
            // fallback on download
            const payload = {type: 'XlsxTicketsExport', option: exportXlsxTicketsOption, ...query}
            const encodedPayload = btoa(JSON.stringify(payload))
            window.open('/download/' + encodedPayload, '_blank')
            onHide()
            return true
        }

        return Promise.resolve(dispatch(exportXlsxTickets())).then(() => {
            onHide()
        })
    }

    _exportPdf() {
        const {dispatch, query, range, exportPdfTicketsOption, ticket, onHide} = this.props

        if (ticket) {
            if (!supportWorker()) {
                // fallback on download
                const payload = {type: 'PdfTicketExport', ticketUid: ticket.uid, option: exportPdfTicketsOption}
                const encodedPayload = btoa(JSON.stringify(payload))
                window.open('/download/' + encodedPayload, '_blank')
                onHide()
                return true
            }

            return Promise.resolve(dispatch(exportPdfTicket())).then(() => {
                onHide()
            })
        }

        if (range.count <= PDF_TICKET_MAX_COUNT) {
            if (!supportWorker()) {
                // fallback on download
                const payload = {type: 'PdfTicketsExport', option: exportPdfTicketsOption, ...query}
                const encodedPayload = btoa(JSON.stringify(payload))
                window.open('/download/' + encodedPayload, '_blank')
                onHide()
                return true
            }

            return Promise.resolve(dispatch(exportPdfTickets())).then(() => {
                onHide()
            })
        }
        dispatch(errorStatus(i18n.maxTicketPdfExportSizeExceeded))
    }

    _reportPdf() {
        const {dispatch, query, reportPdfTicketsOption, onHide} = this.props

        if (!supportWorker()) {
            // fallback on download
            const payload = {type: 'PdfTicketsReport', option: reportPdfTicketsOption, ...query}
            const encodedPayload = btoa(JSON.stringify(payload))
            window.open('/download/' + encodedPayload, '_blank')
            onHide()
            return true
        }

        return Promise.resolve(dispatch(reportPdfTickets())).then(() => {
            onHide()
        })
    }

    _toogle(exportType) {
        if (exportType) {
            this.setState({exportType})
        }
    }

    render() {
        const {dispatch, exportXlsxTicketsForm, exportPdfTicketsForm, reportPdfTicketsForm, exportXlsxTicketsOption, exportPdfTicketsOption, reportPdfTicketsOption, query, range, ticket, onHide, ...others} = this.props
        const {exportTypes, exportType} = this.state

        return (
            <Modal
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{i18n.exportTickets}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={style.exportType}>
                        <ButtonToggle
                            value={exportType}
                            onChange={(exportType) => this._toogle(exportType)}>
                            <ul className={style.container}>
                                {exportTypes.map((exportType, index) => (
                                    <li
                                        key={index}>
                                        <Button
                                            bsStyle='link'
                                            value={exportType}>
                                            <Icon icon={exportType} size='xl' />
                                            <span>{extract(i18n.ticketExportEnum, exportType)}</span>
                                        </Button>
                                    </li>
                                ))}
                            </ul>
                        </ButtonToggle>
                    </div>
                    {exportType == 'ExportXlsx' && (
                        <div>
                            <form>
                                <CheckboxToggle
                                    {...exportXlsxTicketsForm.ticketSheetColumns()}>
                                    <Row>
                                        <Col sm={6}>
                                            {XLSX_TICKET_SHEET_COLUMNS.slice(0, XLSX_TICKET_SHEET_COLUMNS.length / 2).map((column, index) => (
                                                <Input
                                                    key={index}
                                                    type='checkbox'
                                                    label={extract(i18n.xlsxTicketSheetColumnEnum, column)}
                                                    value={column} />
                                            ))}
                                        </Col>
                                        <Col sm={6}>
                                            {XLSX_TICKET_SHEET_COLUMNS.slice(XLSX_TICKET_SHEET_COLUMNS.length / 2, XLSX_TICKET_SHEET_COLUMNS.length).map((column, index) => (
                                                <Input
                                                    key={index}
                                                    type='checkbox'
                                                    label={extract(i18n.xlsxTicketSheetColumnEnum, column)}
                                                    value={column} />
                                            ))}
                                        </Col>
                                    </Row>
                                </CheckboxToggle>
                                <Row>
                                    <Col sm={6} smOffset={6}>
                                        <Input
                                            type='checkbox'
                                            label={i18n.additionalData}
                                            {...checkboxField(exportXlsxTicketsForm.ticketSheetAdditionalData())} />
                                    </Col>
                                </Row>                            
                            </form>
                            <ButtonToolbar>
                                <Button
                                    bsStyle='primary'
                                    bsSize='large'
                                    className={cx({disabled: !exportXlsxTicketsForm.isValid()})}
                                    onClick={() => exportXlsxTicketsForm.validate() && (this._exportXlsx() || true) || dispatch(errorStatus(i18n.formInvalid))}>
                                    {i18n.exportz}
                                </Button>
                                <Button
                                    bsSize='large'
                                    onClick={onHide}>
                                    {i18n.cancel}
                                </Button>
                            </ButtonToolbar>
                        </div>
                    )}
                    {exportType == 'ExportPdf' && (
                        <div>
                            <form>
                                <CheckboxToggle
                                    {...exportPdfTicketsForm.pages()}>
                                    <Row>
                                        <Col sm={6}>
                                            {PDF_EXPORT_PAGES.map((page, index) => (
                                                <Input
                                                    key={index}
                                                    type='checkbox'
                                                    label={extract(i18n.pdfExportPageEnum, page)}
                                                    value={page} />
                                            ))}
                                        </Col>
                                    </Row>
                                </CheckboxToggle>
                            </form>
                            <ButtonToolbar>
                                <Button
                                    bsStyle='primary'
                                    bsSize='large'
                                    onClick={() => this._exportPdf()}>
                                    {i18n.exportz}
                                </Button>
                                <Button
                                    bsSize='large'
                                    onClick={onHide}>
                                    {i18n.cancel}
                                </Button>
                            </ButtonToolbar>
                        </div>
                    )}
                    {exportType == 'ReportPdf' && (
                        <div>
                            <form>
                                <CheckboxToggle
                                    {...reportPdfTicketsForm.pages()}>
                                    <Row>
                                        <Col sm={6}>
                                            {PDF_REPORT_PAGES.slice(0, PDF_REPORT_PAGES.length / 2 + 1).map((page, index) => (
                                                <Input
                                                    key={index}
                                                    type='checkbox'
                                                    label={extract(i18n.pdfReportPageEnum, page)}
                                                    value={page} />
                                            ))}
                                        </Col>
                                        <Col sm={6}>
                                            {PDF_REPORT_PAGES.slice(PDF_REPORT_PAGES.length / 2 + 1, PDF_REPORT_PAGES.length).map((page, index) => (
                                                <Input
                                                    key={index}
                                                    type='checkbox'
                                                    label={extract(i18n.pdfReportPageEnum, page)}
                                                    value={page} />
                                            ))}
                                        </Col>
                                    </Row>
                                    <p className={style.info}>{i18n.reportPdfInfo}</p>
                                </CheckboxToggle>                        
                            </form>
                            <ButtonToolbar>
                                <Button
                                    bsStyle='primary'
                                    bsSize='large'
                                    onClick={() => this._reportPdf()}>
                                    {i18n.exportz}
                                </Button>
                                <Button
                                    bsSize='large'
                                    onClick={onHide}>
                                    {i18n.cancel}
                                </Button>
                            </ButtonToolbar>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        )
    }
}

ExportTicketsModal = connectForm({
    name: 'exportXlsxTicketsForm',
    target: 'exportXlsxTicketsOption',
    alias: 'option',
    schema: ExportXlsxTicketsOption.schema,
    action: EXPORT_XLSX_TICKETS_OPTION_UPDATED
})(ExportTicketsModal)

ExportTicketsModal = connectForm({
    name: 'exportPdfTicketsForm',
    target: 'exportPdfTicketsOption',
    alias: 'option',
    schema: ExportPdfTicketsOption.schema,
    action: EXPORT_PDF_TICKETS_OPTION_UPDATED
})(ExportTicketsModal)

ExportTicketsModal = connectForm({
    name: 'reportPdfTicketsForm',
    target: 'reportPdfTicketsOption',
    alias: 'option',
    schema: ReportPdfTicketsOption.schema,
    action: REPORT_PDF_TICKETS_OPTION_UPDATED
})(ExportTicketsModal)

ExportTicketsModal = connect((state) => ({
    exportXlsxTicketsOption: state.ticket.exportXlsxTicketsOption,
    exportPdfTicketsOption: state.ticket.exportPdfTicketsOption,
    reportPdfTicketsOption: state.ticket.reportPdfTicketsOption,
    query: state.ticket.query,
    range: state.ticket.range
}))(ExportTicketsModal)

export default ExportTicketsModal


// WEBPACK FOOTER //
// ./lib/ticket/components/ExportTicketsModal.js